function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Button, DeleteButton } from './buttons';
import React, { useRef, useState, useEffect } from 'react';
import fileDepositImage from '@rd-web-markets/shared/dist/assets/images/file_deposit.png';
import { useTranslation } from 'react-i18next';
export default function FileUpload(_ref) {
  let {
    storeIsUnderReviewField = 'isUnderTechnicalReview',
    loading = false,
    onSelectFile,
    setLocalFile = () => {},
    file = null,
    title = 'Add Document',
    disabled = false,
    floatRight = false,
    changeFileName = false,
    fileName = '',
    fileDepositDesign = false,
    showDefaultDesignDeleteButton = false,
    // just for backwards compatibility
    defaultDesignCustomStyle = {},
    classesForDefaultBody = '',
    customHandleClick = null,
    onRemoveButtonClick = () => {}
  } = _ref;
  const hiddenFileInput = useRef(null);
  const [selectedFile, setSelectedFile] = useState(file);
  const {
    t
  } = useTranslation();
  const handleClick = () => {
    customHandleClick ? customHandleClick(hiddenFileInput) : hiddenFileInput.current.click();
  };
  const addFile = event => {
    const file = changeFileName ? new File([event.target.files[0]], fileName) : event.target.files[0];
    setSelectedFile(file);
    onSelectFile(file);
    setLocalFile(file);
    event.target.value = '';
  };
  const removeFile = () => {
    setSelectedFile(null);
    onSelectFile(null);
    setLocalFile(null);
    onRemoveButtonClick();
  };
  useEffect(() => {
    setSelectedFile(file);
  }, [file]);
  const inputElement = /*#__PURE__*/React.createElement("input", {
    "data-testid": "input",
    style: {
      display: 'none'
    },
    type: "file",
    ref: hiddenFileInput,
    onChange: e => addFile(e)
  });
  const renderWithFileDepositDesign = /*#__PURE__*/React.createElement("div", {
    className: "text-center",
    style: {
      width: '350px'
    }
  }, selectedFile && /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center justify-content-between",
    style: {
      boxShadow: '0 3px 6px #666e7e4c',
      borderRadius: '5px'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      backgroundColor: '#0078b9',
      border: '#0078b9 solid 8px',
      marginRight: '8px',
      borderRadius: '5px'
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "mat-icon notranslate single-file-icon material-icons mat-icon-no-color",
    style: {
      color: '#fff',
      backgroundColor: '#0078b9',
      fontSize: '24px'
    }
  }, "file_copy")), /*#__PURE__*/React.createElement("span", null, selectedFile.filename || selectedFile.name), /*#__PURE__*/React.createElement("span", {
    onClick: removeFile,
    className: "material-icons md-18 me-1 ps-3 cursor-pointer",
    style: {
      color: '#0078b9',
      fontSize: '28px'
    }
  }, "delete")), /*#__PURE__*/React.createElement("div", {
    onClick: handleClick,
    style: {
      border: '1px dashed #0078b9'
    },
    className: "text-center mt-2"
  }, /*#__PURE__*/React.createElement("img", {
    className: "mt-3",
    src: fileDepositImage
  }), inputElement, /*#__PURE__*/React.createElement("p", {
    className: "mt-4"
  }, t('drag_and_drop_files_here'))));
  const renderDefaultBody = /*#__PURE__*/React.createElement("div", {
    className: classesForDefaultBody,
    style: _objectSpread(_objectSpread({}, {
      width: '200px',
      float: floatRight ? 'right' : ''
    }), defaultDesignCustomStyle)
  }, /*#__PURE__*/React.createElement(Button, {
    isImmutableUnderReview: true,
    storeIsUnderReviewField: storeIsUnderReviewField,
    style: {
      width: '100%'
    },
    variant: "primary",
    onClick: handleClick,
    disabled: disabled || loading
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons md-18 me-1"
  }, "add"), title), inputElement, /*#__PURE__*/React.createElement("p", {
    className: "ms-3"
  }, (selectedFile === null || selectedFile === void 0 ? void 0 : selectedFile.url) && /*#__PURE__*/React.createElement("a", {
    href: selectedFile.url
  }, selectedFile.filename || selectedFile.name, " "), selectedFile && !selectedFile.url && (selectedFile.filename || selectedFile.name)), showDefaultDesignDeleteButton && (selectedFile === null || selectedFile === void 0 ? void 0 : selectedFile.id) && /*#__PURE__*/React.createElement("div", {
    className: "ms-3"
  }, /*#__PURE__*/React.createElement(DeleteButton, {
    onClick: removeFile
  })));

  /**
  * fileDepositDesign uses an icon for the design system and 
  * shows the selected file with a delete icon also as per
  * ayming design system
  */

  if (fileDepositDesign) {
    return renderWithFileDepositDesign;
  } else {
    return renderDefaultBody;
  }
}